"use client";

import { useRouter } from "next/navigation";
import Button, { ButtonType } from "@/app/(components)/generics/Button/Button";
import IconTarget from "@/app/(components)/generics/Icons/IconTarget/IconTarget";
import { ProjectAction } from "@/app/(components)/specifics/projet/Project/Project.logic";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { PageParams } from "@/app/types/common/DefaultProps";
import { URLs } from "@/app/utils/URLs";
import { Routes } from "@/app/vars/Routes";
import { UrlParam, UrlRedirect } from "@/app/vars/Urls";
import styles from "./NoOfferCard.module.css";

type Props = {
  params: PageParams;
};

export default function NoOfferCard(_props: Props) {
  const T = useT();
  const router = useRouter();

  const handleCreateOffer = () => {
    const url = `${URLs.pathOf(Routes.PROTECTED.OFFERS)}?${UrlParam.ACTION}=${ProjectAction.CREATE_OFFER}&${UrlParam.REDIRECT}=${UrlRedirect.CLIENT_AVATAR}`;
    router.push(url);
  };

  return (
    <div className={styles.card}>
      <div className={styles.iconContainer}>
        <IconTarget size={28} />
      </div>
      <div className={styles.content}>
        <div className={styles.header}>
          <h2 className={styles.title}>{T(TKey.CLIENT_AVATAR_NO_OFFER_TITLE)}</h2>
          <span className={styles.badge}>{T(TKey.CLIENT_AVATAR_NO_OFFER_BADGE)}</span>
        </div>
        <p className={styles.description}>{T(TKey.CLIENT_AVATAR_NO_OFFER_DESCRIPTION)}</p>
        <div className={styles.actions}>
          <Button
            min={true}
            isLink={false}
            type={ButtonType.PRIMARY}
            text={T(TKey.CLIENT_AVATAR_NO_OFFER_CREATE_BUTTON) as string}
            onClick={handleCreateOffer}
          />
        </div>
      </div>
    </div>
  );
}
